import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import logger from 'loglevel';
import { Deferred } from 'class-deferred';
import { BaseBroker } from "./BaseBroker";
logger.setLevel(logger.levels.INFO);
/**
 * Брокер для передачи команд через IPC Node.js
 * Может работать как в родительском процессе (с дочерним процессом),
 * так и в дочернем процессе (с родительским)
 */
export var ProcessBroker = /*#__PURE__*/function (_BaseBroker) {
  _inherits(ProcessBroker, _BaseBroker);
  var _super = _createSuper(ProcessBroker);
  function ProcessBroker() {
    var _this;
    _classCallCheck(this, ProcessBroker);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "childProcess", void 0);
    _defineProperty(_assertThisInitialized(_this), "asyncProcess", new Deferred());
    _defineProperty(_assertThisInitialized(_this), "handleDisconnect", function () {
      logger.info('[ProcessBroker] Disconnected');
      _this.asyncProcess = new Deferred();
    });
    return _this;
  }
  _createClass(ProcessBroker, [{
    key: "connect",
    value: function connect(childProcess) {
      if (!childProcess) {
        // Проверяем, что IPC канал доступен
        if (!process.send) {
          throw new Error('Process is not running with IPC channel');
        }
        this.asyncProcess.resolve(process);
        process.on('message', this.receive.bind(this));
        process.on('disconnect', this.handleDisconnect);
        logger.info('[ProcessBroker] Started');
        return;
      }
      this.childProcess = childProcess;
      this.asyncProcess.resolve(this.childProcess);
      this.childProcess.on('message', this.receive.bind(this));
      this.childProcess.on('exit', this.handleDisconnect);
      this.childProcess.on('error', this.handleDisconnect);
      logger.info('[ProcessBroker] Started');
    }
  }, {
    key: "onReady",
    value: function () {
      var _onReady = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cb) {
        var process;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.asyncProcess;
            case 2:
              process = _context.sent;
              if (process) cb();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function onReady(_x) {
        return _onReady.apply(this, arguments);
      }
      return onReady;
    }()
  }, {
    key: "send",
    value: function send(msg, extra, ack) {
      if (typeof ack === 'function') {
        /** @class RoundTripCommand */
        throw new Error('ProcessBroker не поддерживает требующие ответа команды (RoundTripCommand)');
      }
      try {
        var _ref, _ref$send;
        (_ref = this.childProcess || process) === null || _ref === void 0 ? void 0 : (_ref$send = _ref.send) === null || _ref$send === void 0 ? void 0 : _ref$send.call(_ref, msg);
      } catch (err) {
        console.error('[ProcessBroker]: Unable to send message');
        throw err;
      }
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      if (this.childProcess) {
        this.childProcess.kill();
        this.childProcess = undefined;
        this.handleDisconnect();
      }
    }
  }]);
  return ProcessBroker;
}(BaseBroker);